<app-stacked-bars-row *ngIf="stackedBarConfig?.length > 0" [stackedBarConfig]="stackedBarConfig" [height]="height" [width]="width"></app-stacked-bars-row>
